import {
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "@/app/shared/components";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar
  },
  data() {
    return {
      model: {
        companyId: 0,
        name: "",
        shortName: "",
        address: "",
        city: "",
        province: "",
        contact: "",
        telephone: "",
        email: ""
      }
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    companies() {
      return this.$store.state.drilling.companies;
    },
    telephoneFormatted: {
      // getter
      get() {
        return this.model.telephone;
      },
      set(newValue) {
        newValue = newValue.replace(/-/g, '').replace(/\./g, '').slice(0, 10);
        if (newValue.length >= 3 && newValue.length < 7) {
          newValue = newValue.substring(0, 3) + "-" + newValue.substring(3, newValue.length);
        } else if (newValue.length >= 7) {
          newValue = (newValue.substring(0, 3) + "-" + newValue.substring(3, 6) + "-" + newValue.substring(6, newValue.length));
        }
        this.model.telephone = newValue;
      }
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      this.model = this.data;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.companyId) return;
      this.model = {
        companyId: 0,
        name : "",
        shortName : "",
        address : "",
        city : "",
        province : "",
        contact : "",
        telephone : "",
        email : ""
      }
    },
    submitData() {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          if (this.model.companyId !== null && this.model.companyId > 0) {
            this.$store
              .dispatch("drilling/updateCompany", this.model)
              .then((response) => {
                this.$emit("onUpdated", response.data);
              })
              .finally(() => {
                this.$vs.loading.close();
              });
          } else {
            this.$store
              .dispatch("drilling/addCompany", this.model)
              .then((response) => {
                this.$emit("onInserted", response.data);
                this.model.companyId = response.data.companyId;
              })
              .finally(() => {
                this.$vs.loading.close();
              });
          }
        }
      });
    }
  }
};
